import { useSelector } from 'react-redux';

const Translate = ({dictionary}) => {
    const {language} = useSelector(state => state.account)
    return dictionary[language]
}

export default Translate;
